
import Vue, { PropType } from 'vue';
import {
  CvIconButton,
  CvComboBox,
  CvDropdown,
  CvDropdownItem,
} from '@carbon/vue';
import {
  TextAlignLeft20,
  TextAlignCenter20,
  TextAlignRight20,
  TextBold20,
  TextItalic20,
} from '@carbon/icons-vue';
import DropDown from './DropDown.vue';
import { colorArrayToColorRGBA } from '@/utils';
import { fontSizesList } from '@/constants/fontSizes';
import { fontList } from '@/constants/fontList';
import { ColorDropdown } from '@/web-components/import-wizard/components/sections/color-management/ColorDropdown';
import {
  CustomDropdown,
  CustomDropdownItem,
} from '../../libs/proof-approval/proofVersions/CustomDropdown';
import { PmsColor } from '@midocean/webapps-shared-domain';

export default Vue.extend({
  name: 'TipTapToolbar',
  components: {
    CvIconButton,
    TextAlignLeft20,
    TextAlignCenter20,
    TextAlignRight20,
    TextBold20,
    TextItalic20,
    CvComboBox,
    DropDown,
    ColorDropdown,
    CvDropdown,
    CvDropdownItem,
    CustomDropdown,
    CustomDropdownItem,
  },
  props: {
    attributes: {
      type: Object,
      required: true,
    },

    colorList: {
      type: Array as PropType<PmsColor[]>,
      default() {
        return [];
      },
    },

    hideColorsDropdown: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
      fontList: fontList,
      sizeList: fontSizesList,
    };
  },
  computed: {
    rgba() {
      return colorArrayToColorRGBA(this.attributes.color);
    },
    selectedPmsColor(): PmsColor {
      return (
        this.colorList.find((c) => c.name === this.attributes.colorName) ||
        ({} as PmsColor)
      );
    },
    allPmsColors(): PmsColor[] {
      return this.colorList;
    },
  },
  watch: {
    attributes() {
      const elementInWC = document.querySelector('w2p-import-wizard-wrapper');
      const oldVersionInWc = document.querySelector('w2p-import-wizard');
      if (elementInWC?.shadowRoot) {
        const fontFamilyLabel = elementInWC.shadowRoot.querySelectorAll(
          '.bx--list-box__field'
        )[0] as HTMLElement;
        fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
      } else if (oldVersionInWc && oldVersionInWc.shadowRoot) {
        const fontFamilyLabel = oldVersionInWc.shadowRoot.querySelectorAll(
          '.bx--list-box__field'
        )[0] as HTMLElement;
        fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
      } else {
        const fontFamilyLabel = document.querySelectorAll(
          '.bx--list-box__field'
        )[0] as HTMLElement;
        fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
      }
    },
  },
  mounted() {
    const wrapperClass = 'bx--dropdown-list';
    const selectedFont = (
      fontList.find((font) => font.label === this.attributes.fontFamily) || {
        id: '',
      }
    ).id.toString();
    const selectedSize = (
      fontSizesList.find(
        (size) => size.label === this.attributes.fontSizePT
      ) || {
        id: '',
      }
    ).id.toString();
    const elementInWC = document.querySelector('w2p-import-wizard-wrapper');
    if (elementInWC?.shadowRoot) {
      const fontFamilywrapper = elementInWC.shadowRoot
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];
      const fontSizeWrapper = elementInWC.shadowRoot
        .querySelectorAll('.font-size-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];

      fontFamilywrapper.scroll(0, 38 * +selectedFont);
      fontSizeWrapper.scroll(0, 38 * +selectedSize);

      const fontFamilyLabels = elementInWC.shadowRoot
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];

      var itemsCollectionShadow =
        fontFamilyLabels.getElementsByClassName('cv-dropdown-item');

      for (let i = 0; i < fontFamilyLabels.childNodes.length; i++) {
        var htmlElementShadow = itemsCollectionShadow[i] as HTMLElement;
        htmlElementShadow.style.fontFamily = fontList[i].label;
        htmlElementShadow.style.fontSize = '9pt';
      }

      const fontFamilyLabel = elementInWC.shadowRoot.querySelectorAll(
        '.bx--list-box__field'
      )[0] as HTMLElement;

      fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
    }

    const oldVersionInWc = document.querySelector('w2p-import-wizard');
    if (oldVersionInWc?.shadowRoot) {
      const fontFamilywrapper = oldVersionInWc.shadowRoot
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];
      const fontSizeWrapper = oldVersionInWc.shadowRoot
        .querySelectorAll('.font-size-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];

      fontFamilywrapper.scroll(0, 38 * +selectedFont);
      fontSizeWrapper.scroll(0, 38 * +selectedSize);

      const fontFamilyLabels = oldVersionInWc.shadowRoot
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];

      var itemsCollectionShadowOld =
        fontFamilyLabels.getElementsByClassName('cv-dropdown-item');

      for (let i = 0; i < fontFamilyLabels.childNodes.length; i++) {
        var htmlElementShadowOld = itemsCollectionShadowOld[i] as HTMLElement;
        htmlElementShadowOld.style.fontFamily = fontList[i].label;
        htmlElementShadowOld.style.fontSize = '9pt';
      }

      const fontFamilyLabel = oldVersionInWc.shadowRoot.querySelectorAll(
        '.bx--list-box__field'
      )[0] as HTMLElement;

      fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
    }

    if (!elementInWC?.shadowRoot && !oldVersionInWc?.shadowRoot) {
      const fontFamilywrapper = document
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];
      const fontSizeWrapper = document
        .querySelectorAll('.font-size-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];

      fontFamilywrapper.scroll(0, 38 * +selectedFont);
      fontSizeWrapper.scroll(0, 38 * +selectedSize);

      const fontFamilyLabels = document
        .querySelectorAll('.font-family-dropdown')[0]
        .getElementsByClassName(wrapperClass)[0];
      var itemsCollection =
        fontFamilyLabels.getElementsByClassName('cv-dropdown-item');

      for (let i = 0; i < fontFamilyLabels.childNodes.length; i++) {
        var htmlElement = itemsCollection[i] as HTMLElement;
        htmlElement.style.fontFamily = fontList[i].label;
        htmlElement.style.fontSize = '9pt';
      }

      const fontFamilyLabel = document.querySelectorAll(
        '.bx--list-box__field'
      )[0] as HTMLElement;

      fontFamilyLabel.style.fontFamily = this.attributes.fontFamily;
    }
  },
  methods: {
    log: console.log,
    colorArrayToColorRGBA,
  },
});
